import { Trophy, Check, X, MinusCircle } from "lucide-react";

const MARKET_ORDER = [
  "even_balls",
  "first_ball_scoring",
  "even_runs",
  "boundary",
  "six",
  "dot_balls_gt3",
  "wicket",
  "runs_gt7",
];

const MARKET_LABELS = {
  even_balls: "Double Runs",
  first_ball_scoring: "1st Ball Scores",
  even_runs: "Even Over Runs",
  boundary: "Boundary",
  six: "Six",
  dot_balls_gt3: "3+ Dot Balls",
  wicket: "Wicket",
  runs_gt7: "7+ Runs",
};

function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function OverCard({ g }) {
  const hasPending = g.pending_count > 0;
  const resolvedAt = g.evaluated_at || g.created_at;
  return (
    <div className="tile p-5 grain" data-testid={`history-over-card-${g.match_id}-${g.over_number}`}>
      <div className="flex items-start justify-between flex-wrap gap-3 mb-4">
        <div>
          <div className="font-display font-black uppercase text-xl tracking-tight flex items-center gap-2">
            {g.match_title || g.match_id} · Over #{g.over_number}
            {g.is_live && <span className="pill bg-emerald-500/15 text-emerald-300 border border-emerald-500/40 text-[9px]">Real</span>}
          </div>
          <div className="text-xs text-slate-500 font-mono-data mt-0.5">{hasPending ? "Locked at" : "Resolved"} · {fmtDate(resolvedAt)}</div>
        </div>
        <div className="flex items-center gap-2">
          {hasPending ? (
            <span className="pill bg-sky-500/15 text-sky-300 border border-sky-500/30">Pending · {g.pending_count} of {g.picks_count}</span>
          ) : (
            <span className="pill bg-emerald-500/15 text-emerald-300 border border-emerald-500/40">
              <Check className="w-3 h-3" />{g.correct_count}/{g.picks_count} correct
            </span>
          )}
          <span className="pill bg-amber-500/15 text-amber-300 border border-amber-500/40">
            <Trophy className="w-3 h-3" />+{g.total_points} pts
          </span>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {MARKET_ORDER.map((mid) => (
          <MarketRow key={mid} label={MARKET_LABELS[mid]} pick={g.picks_by_market[mid]} testidBase={`${g.match_id}-${g.over_number}-${mid}`} />
        ))}
      </div>
    </div>
  );
}

function MarketRow({ label, pick, testidBase }) {
  if (!pick) {
    return (
      <div className="tile-elev p-2.5 opacity-50" data-testid={`history-market-${testidBase}`}>
        <div className="text-[10px] uppercase tracking-wider text-slate-500 font-mono-data">{label}</div>
        <div className="mt-1 text-xs text-slate-500 flex items-center gap-1"><MinusCircle className="w-3 h-3" /> not picked</div>
      </div>
    );
  }
  const won = pick.status === "won";
  const lost = pick.status === "lost";
  const pending = pick.status === "pending";
  return (
    <div
      className={`tile-elev p-2.5 ${won ? "ring-1 ring-emerald-400/50" : lost ? "ring-1 ring-rose-500/40" : ""}`}
      data-testid={`history-market-${testidBase}`}
    >
      <div className="text-[10px] uppercase tracking-wider text-slate-500 font-mono-data">{label}</div>
      <div className="mt-1 flex items-center justify-between">
        <span className={`text-xs font-bold uppercase ${pick.answer === "Yes" ? "text-emerald-300" : "text-rose-300"}`}>{pick.answer}</span>
        <span className="text-[10px] text-slate-500">→</span>
        <span className={`text-xs font-bold ${
          pending ? "text-slate-400" : won ? "text-emerald-300" : "text-rose-300"
        }`}>{pending ? "…" : (pick.correct_answer || "—")}</span>
      </div>
      <div className="mt-1 text-[10px] font-mono-data flex items-center justify-between">
        <span className={won ? "text-emerald-400" : lost ? "text-rose-400" : "text-sky-400"}>
          {won ? <><Check className="w-3 h-3 inline" /> won</> : lost ? <><X className="w-3 h-3 inline" /> missed</> : "pending"}
        </span>
        <span className="text-slate-500">{pick.points_earned ? `+${pick.points_earned}` : ""}</span>
      </div>
    </div>
  );
}
